import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import BrowseBanner from 'Components/Banner/BrowseBanner/BrowseBanner';
import imgixConfig from 'Config/imgix';
import Price from 'Components/Price/Price';
import pricing from 'Helpers/Price/games-under-pricing';
import BrowseButton from 'Components/Button/BrowseButton';
import TrackedLink from 'Components/Behaviour/Linking/TrackedLink';
import useViewport from 'Hooks/useViewport';

export default function QuickLinks() {
  const { formatMessage } = useIntl();

  const { isAboveMd } = useViewport();

  const messages = {
    gameBundles: {
      id: 'home.quick.gameBundles',
      defaultMessage: 'Game Bundles',
    },
    onSale: {
      id: 'home.quick.onSale',
      defaultMessage: 'On Sale',
    },
    latestDeals: {
      id: 'home.quick.latestDeals',
      defaultMessage: 'Latest Deals',
    },
    topSellers: {
      id: 'home.quick.topSellers',
      defaultMessage: 'Top Sellers',
    },
    gamesUnderFive: {
      id: 'home.quick.gamesUnderFive',
      defaultMessage: 'Games Under £5',
    },
    vrGames: {
      id: 'home.quick.vrGames',
      defaultMessage: 'VR Games',
    },
    multiplayerGames: {
      id: 'home.quick.multiplayerGames',
      defaultMessage: 'Multiplayer Games',
    },
    lastChanceToSave: {
      id: 'home.quick.lastChanceToSave',
      defaultMessage: 'Last Chance to Save',
    },
    trendingDeals: {
      id: 'home.quick.trendingDeals',
      defaultMessage: 'Trending Deals',
    },
    bestGamesOf2025: {
      id: 'home.quick.bestGamesOf2025',
      defaultMessage: 'Best Games of 2025',
    },
    newReleases: {
      id: 'home.quick.newReleases',
      defaultMessage: 'New Releases',
    },
    macGames: {
      id: 'home.quick.macGames',
      defaultMessage: 'Mac Games',
    },
    steamDeckGames: {
      id: 'home.quick.steamDeckGames',
      defaultMessage: 'Steam Deck Games',
    },
    xboxGames: {
      id: 'home.quick.xboxGames',
      defaultMessage: 'Xbox Games',
    },
    giftCards: {
      id: 'home.quick.giftCards',
      defaultMessage: 'Gift Cards',
    },
  };

  const showVisualBanners = isAboveMd;

  return (
    <section className="quick-links container">
      {!showVisualBanners &&
        <>
          <div className="section-heading-container">
            <h2>
              <FormattedMessage id="home.quick.browse" defaultMessage="Browse Fanatical" />
            </h2>
          </div>
          <div className="quicklinks-container">
            <div className="quick-link">
              <TrackedLink to="/bundle/games" type="frontend/click/CLICK_INTERACTION" section="BrowseFanatical">
                <FormattedMessage id="home.quick.bundles" defaultMessage="Game Bundles" />
              </TrackedLink>
            </div>
            <div className="quick-link">
              <TrackedLink to="/on-sale" type="frontend/click/CLICK_INTERACTION" section="BrowseFanatical">
                <FormattedMessage id="home.quick.onsale" defaultMessage="On Sale Now" />
              </TrackedLink>
            </div>
            <div className="quick-link">
              <TrackedLink to="/latest-deals" type="frontend/click/CLICK_INTERACTION" section="BrowseFanatical">
                <FormattedMessage id="home.quick.latest" defaultMessage="Latest Deals" />
              </TrackedLink>
            </div>
            <div className="quick-link">
              <TrackedLink to="/top-sellers" type="frontend/click/CLICK_INTERACTION" section="BrowseFanatical">
                <FormattedMessage id="home.quick.topsellers" defaultMessage="Top Sellers" />
              </TrackedLink>
            </div>
            <div className="quick-link">
              <TrackedLink to="/games-under/5" type="frontend/click/CLICK_INTERACTION" section="BrowseFanatical">
                <FormattedMessage
                  id="home.quick.under"
                  defaultMessage="Games Under {price}"
                  tagName="span"
                  values={{
                    price: <Price
                      hideDecimals
                      price={pricing['5'].max}
                    />,
                  }}
                />
              </TrackedLink>
            </div>
            <div className="quick-link">
              <TrackedLink to="/vr-games" type="frontend/click/CLICK_INTERACTION" section="BrowseFanatical">
                <FormattedMessage id="home.quick.vrgames" defaultMessage="VR Games" />
              </TrackedLink>
            </div>
            <div className="quick-link">
              <TrackedLink to="/categories/rpg" type="frontend/click/CLICK_INTERACTION" section="BrowseFanatical">
                <FormattedMessage id="home.quick.rpgames" defaultMessage="Role Playing Games" />
              </TrackedLink>
            </div>
            <div className="quick-link">
              <TrackedLink to="/ending-soon" type="frontend/click/CLICK_INTERACTION" section="BrowseFanatical">
                <FormattedMessage id="home.quick.lastchance" defaultMessage="Last Chance to Save" />
              </TrackedLink>
            </div>
            <div className="quick-link">
              <TrackedLink to="/categories/anime" type="frontend/click/CLICK_INTERACTION" section="BrowseFanatical">
                <FormattedMessage id="home.quick.animegames" defaultMessage="Anime Games" />
              </TrackedLink>
            </div>
            <div className="quick-link">
              <TrackedLink to="/bundle/books" type="frontend/click/CLICK_INTERACTION" section="BrowseFanatical">
                <FormattedMessage id="home.quick.books" defaultMessage="Books" />
              </TrackedLink>
            </div>
            <div className="quick-link">
              <TrackedLink to="/categories/party" type="frontend/click/CLICK_INTERACTION" section="BrowseFanatical">
                <FormattedMessage id="home.quick.fpsgames" defaultMessage="Party Games" />
              </TrackedLink>
            </div>
            <div className="quick-link">
              <TrackedLink to="/trending-deals" type="frontend/click/CLICK_INTERACTION" section="BrowseFanatical">
                <FormattedMessage id="home.quick.trendingdeals" defaultMessage="Trending Deals" />
              </TrackedLink>
            </div>
            <div className="quick-link">
              <TrackedLink to="/new-releases" type="frontend/click/CLICK_INTERACTION" section="BrowseFanatical">
                <FormattedMessage id="home.quick.newreleases" defaultMessage="New Releases" />
              </TrackedLink>
            </div>
            <div className="quick-link">
              <TrackedLink to="/best-games-of-2025" type="frontend/click/CLICK_INTERACTION" section="BrowseFanatical">
                <FormattedMessage id="home.quick.bestgamesof2025" defaultMessage="Best Games of 2025" />
              </TrackedLink>
            </div>
            <div className="quick-link">
              <TrackedLink to="/search" type="frontend/click/CLICK_INTERACTION" section="BrowseFanatical">
                <FormattedMessage id="home.quick.browseall" defaultMessage="Browse All" />
              </TrackedLink>
            </div>
          </div>
        </>
      }

      {showVisualBanners &&
        <>
          <div className="section-heading-container">
            <h2>
              <FormattedMessage id="home.quick.browse" defaultMessage="Browse Fanatical" />
            </h2>
            <BrowseButton className={'view-all-btn'} location="search" />
          </div>
          <div className="container p-0">
            <div className="BrowseLinks">
              <div className="BrowseLinks__main">
                <BrowseBanner
                  squareDesign
                  position="center"
                  title={formatMessage(messages.gameBundles)}
                  pathname="/bundle/games"
                  backgroundImage={`https://cdn.fanatical.com/production/assets/banners/homepage/browse-fanatical/game-bundles.png?${imgixConfig}`}
                />
                <BrowseBanner
                  squareDesign
                  position="center"
                  title={formatMessage(messages.onSale)}
                  pathname="/on-sale"
                  backgroundImage={`https://cdn.fanatical.com/production/assets/banners/homepage/browse-fanatical/on-sale.png?${imgixConfig}`}
                />
                <BrowseBanner
                  squareDesign
                  position="center"
                  title={formatMessage(messages.latestDeals)}
                  pathname="/latest-deals"
                  backgroundImage={`https://cdn.fanatical.com/production/assets/banners/homepage/browse-fanatical/latest-deals-v2.png?${imgixConfig}`}
                />
                <BrowseBanner
                  squareDesign
                  position="center"
                  title={formatMessage(messages.gamesUnderFive)}
                  pathname="/games-under/5"
                  backgroundImage={`https://cdn.fanatical.com/production/assets/banners/homepage/browse-fanatical/games-under-five.png?${imgixConfig}`}
                />
                <BrowseBanner
                  squareDesign
                  position="center"
                  title={formatMessage(messages.steamDeckGames)}
                  pathname="/steam-deck-games"
                  backgroundImage={`https://cdn.fanatical.com/production/assets/banners/homepage/browse-fanatical/steam-deck-games.png?${imgixConfig}`}
                />
              </div>
              <div className="BrowseLinks__supporting">
                <TrackedLink to="/top-sellers" type="frontend/click/CLICK_INTERACTION" section="BrowseFanatical" className="BrowseLinks__supporting__link">
                  <FormattedMessage id="home.quick.topsellers" defaultMessage="Top Sellers" />
                </TrackedLink>
                <TrackedLink to="/vr-games" type="frontend/click/CLICK_INTERACTION" section="BrowseFanatical" className="BrowseLinks__supporting__link">
                  <FormattedMessage id="home.quick.vrgames" defaultMessage="VR Games" />
                </TrackedLink>
                <TrackedLink to="/ending-soon" type="frontend/click/CLICK_INTERACTION" section="BrowseFanatical" className="BrowseLinks__supporting__link">
                  <FormattedMessage id="home.quick.lastchance" defaultMessage="Last Chance to Save" />
                </TrackedLink>
                <TrackedLink to="/categories/multiplayer" type="frontend/click/CLICK_INTERACTION" section="BrowseFanatical" className="BrowseLinks__supporting__link">
                  <FormattedMessage id="home.quick.multiplayergames" defaultMessage="Multiplayer Games" />
                </TrackedLink>
                <TrackedLink to="/trending-deals" type="frontend/click/CLICK_INTERACTION" section="BrowseFanatical" className="BrowseLinks__supporting__link">
                  <FormattedMessage id="home.quick.trendingdeals" defaultMessage="Trending Deals" />
                </TrackedLink>
                <TrackedLink to="/new-releases" type="frontend/click/CLICK_INTERACTION" section="BrowseFanatical" className="BrowseLinks__supporting__link">
                  <FormattedMessage id="home.quick.newreleases" defaultMessage="New Releases" />
                </TrackedLink>
                <TrackedLink to="/best-games-of-2025" type="frontend/click/CLICK_INTERACTION" section="BrowseFanatical" className="BrowseLinks__supporting__link">
                  <FormattedMessage id="home.quick.bestgamesof2025" defaultMessage="Best Games of 2025" />
                </TrackedLink>
                <TrackedLink to="/gift-cards" type="frontend/click/CLICK_INTERACTION" section="BrowseFanatical" className="BrowseLinks__supporting__link">
                  <FormattedMessage id="home.quick.giftcards" defaultMessage="Gift Cards" />
                </TrackedLink>
                <TrackedLink to="/mac-games" type="frontend/click/CLICK_INTERACTION" section="BrowseFanatical" className="BrowseLinks__supporting__link">
                  <FormattedMessage id="home.quick.macgames" defaultMessage="Mac Games" />
                </TrackedLink>
                <TrackedLink to="/publishers/xbox" type="frontend/click/CLICK_INTERACTION" section="BrowseFanatical" className="BrowseLinks__supporting__link">
                  <FormattedMessage id="home.quick.xboxgames" defaultMessage="Xbox Games" />
                </TrackedLink>
              </div>
            </div>
          </div>
        </>
      }
    </section>
  );
}
